import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GOLD = "#c8956c";
const GOLD2 = "#e8b48a";
const DARK = "#1c1712";
const CREAM = "#fdf8f3";

const ROOM_COLORS = {
  "Superior Suite":           { bg: "#8e44ad", light: "rgba(142,68,173,0.13)", text: "#8e44ad", gradient: "linear-gradient(90deg,#8e44ad,#a855f7)" },
  "Double Room with Balcony": { bg: "#2980b9", light: "rgba(41,128,185,0.13)", text: "#2980b9", gradient: "linear-gradient(90deg,#2980b9,#3b9fd4)" },
  "Triple Room":              { bg: "#27ae60", light: "rgba(39,174,96,0.13)",  text: "#27ae60", gradient: "linear-gradient(90deg,#27ae60,#2ecc71)" },
  "Double Room with Garden":  { bg: GOLD,     light: "rgba(200,149,108,0.13)", text: GOLD,     gradient: "linear-gradient(90deg,#c8956c,#e8b48a)" },
  "default":                  { bg: "#7f8c8d", light: "rgba(127,140,141,0.13)",text: "#7f8c8d", gradient: "linear-gradient(90deg,#7f8c8d,#95a5a6)" },
};

function getRoomColor(rn) {
  if (!rn) return ROOM_COLORS.default;
  const key = Object.keys(ROOM_COLORS).find(k => rn.includes(k));
  return ROOM_COLORS[key] || ROOM_COLORS.default;
}
function getRoomShort(rn) {
  if (!rn) return "Room";
  if (rn.includes("Suite"))   return "Superior Suite";
  if (rn.includes("Balcony")) return "Balcony Sea View";
  if (rn.includes("Triple"))  return "Triple Sea View";
  if (rn.includes("Garden"))  return "Garden View";
  return rn;
}

const OWNER_ACCOUNTS = {
  "eva.mici":     { name: "Eva Mici",     property: "Vila Eva",       propId: "310821", commissionPct: 10, location: "Qerret, Kavaje", units: 7 },
  "anja.doksani": { name: "Anja Doksani", property: "Dahlila Home",   propId: "317371", commissionPct: 50, location: "Pogradec",       units: 2 },
};

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAYS_SHORT = ["M","T","W","T","F","S","S"];

export default function OwnerDashboard() {
  const navigate = useNavigate();
  const [owner,       setOwner]       = useState(null);
  const [tab,         setTab]         = useState("dashboard");
  const [bookings,    setBookings]    = useState(null);
  const [loading,     setLoading]     = useState(false);
  const [calMonth,    setCalMonth]    = useState(new Date().getMonth());
  const [calYear,     setCalYear]     = useState(new Date().getFullYear());
  const [selectedBkg, setSelectedBkg] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("ownerToken");
    const u     = localStorage.getItem("ownerUser");
    if (!token || !u) { navigate("/owner"); return; }
    const ownerData = JSON.parse(u);
    const account   = OWNER_ACCOUNTS[ownerData.username];
    if (!account)   { navigate("/owner"); return; }
    setOwner({ ...ownerData, ...account });
  }, [navigate]);

  useEffect(() => { if (owner && !bookings) fetchBookings(); }, [owner]);

  function logout() {
    localStorage.removeItem("ownerToken");
    localStorage.removeItem("ownerUser");
    navigate("/owner");
  }

  function fetchBookings() {
    if (!owner || loading) return;
    setLoading(true);
    fetch("/api/beds24/bookings")
      .then(r => r.json())
      .then(res => {
        if (res.success && res.data && res.data.data) {
          const filtered = res.data.data.filter(function(b) {
            return String(b.propertyId) === String(owner.propId) &&
              b.firstName !== "Block" && b.status !== "cancelled";
          });
          setBookings(filtered);
        } else { setBookings([]); }
        setLoading(false);
      })
      .catch(() => { setBookings([]); setLoading(false); });
  }

  function calcNights(a, d) {
    if (!a || !d) return 0;
    return Math.round((new Date(d) - new Date(a)) / 86400000);
  }
  function formatD(str) { return str ? str.split("T")[0] : ""; }
  function guestName(b) {
    return ((b.firstName || "") + (b.lastName ? " " + b.lastName : "")).trim() || "Guest";
  }
  function roomName(b) {
    const m = b.apiMessage && b.apiMessage.match(/Room: ([^\n]+)/);
    return m ? m[1].trim() : "Room " + (b.roomId || "");
  }
  function getSource(b) {
    const src = b.referer || b.channel || "Direct";
    if (src.toLowerCase().includes("booking")) return "Booking.com";
    if (src.toLowerCase().includes("airbnb"))  return "Airbnb";
    return "Direct";
  }

  if (!owner) return null;

  const commPct   = owner.commissionPct;
  const today     = new Date();
  const todayStr  = today.toISOString().split("T")[0];
  const allBkg    = bookings || [];
  const tRev      = allBkg.reduce(function(s,b){ return s + parseFloat(b.price||0); }, 0);
  const tNights   = allBkg.reduce(function(s,b){ return s + calcNights(b.arrival,b.departure); }, 0);
  const ownerNet  = tRev - (tRev * commPct / 100);
  const upcoming  = allBkg.filter(function(b){ return b.arrival && new Date(b.arrival) > today; })
    .sort(function(a,b){ return new Date(a.arrival) - new Date(b.arrival); });
  const arrivalsToday  = allBkg.filter(function(b){ return b.arrival   === todayStr; });
  const departingToday = allBkg.filter(function(b){ return b.departure === todayStr; });

  const NAV = [
    { id: "dashboard", ico: "📊", label: "Dashboard" },
    { id: "bookings",  ico: "📅", label: "Calendar"  },
    { id: "revenue",   ico: "💶", label: "Revenue"   },
  ];

  const CS = {
    card:      { background:"#fff", border:"1px solid rgba(200,149,108,0.15)", borderRadius:16, boxShadow:"0 2px 20px rgba(28,23,18,0.06)", overflow:"hidden" },
    ch:        { padding:"15px 20px 12px", borderBottom:"1px solid rgba(200,149,108,0.08)", display:"flex", justifyContent:"space-between", alignItems:"center" },
    cb:        { padding:"16px 20px" },
    ct:        { fontFamily:"'Cormorant Garamond',serif", fontSize:"1.05rem", fontWeight:400, color:DARK },
    m:         { background:"#fff", border:"1px solid rgba(200,149,108,0.15)", borderRadius:14, padding:"16px 18px", boxShadow:"0 2px 12px rgba(28,23,18,0.05)" },
    mg:        { borderColor:"rgba(200,149,108,0.35)", background:"linear-gradient(135deg,rgba(200,149,108,0.06),#fff)" },
    ml:        { fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:".12em", color:"rgba(28,23,18,0.35)", marginBottom:8 },
    mv:        { fontFamily:"'Cormorant Garamond',serif", fontSize:"1.85rem", fontWeight:400, lineHeight:1 },
  };

  // ── DASHBOARD ──
  function renderDashboard() {
    return (
      <div>
        <div style={{ background:DARK, borderRadius:20, padding:"26px 30px", marginBottom:22, position:"relative", overflow:"hidden" }}>
          <div style={{ position:"absolute", top:"-20%", right:"5%", width:320, height:320, background:"radial-gradient(circle,rgba(200,149,108,0.18),transparent 65%)", pointerEvents:"none" }} />
          <div style={{ fontSize:9, fontWeight:700, letterSpacing:3, textTransform:"uppercase", color:GOLD, opacity:.85, marginBottom:7 }}>Your Property · Live from Beds24</div>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"2rem", fontWeight:300, color:"#fff", marginBottom:4 }}>{owner.property}</div>
          <div style={{ fontSize:12, color:"rgba(255,255,255,0.3)" }}>{owner.location} · {owner.units} units</div>
          <div style={{ display:"flex", gap:10, marginTop:16, flexWrap:"wrap", alignItems:"center" }}>
            <div style={{ display:"inline-flex", alignItems:"center", gap:5, background:"rgba(39,174,96,0.15)", border:"1px solid rgba(39,174,96,0.3)", borderRadius:999, padding:"4px 12px", fontSize:11, fontWeight:600, color:"#4caf50" }}>
              <div style={{ width:6, height:6, background:"#4caf50", borderRadius:"50%" }} />
              Live on Booking.com & Airbnb
            </div>
            <button onClick={function(){ setBookings(null); fetchBookings(); }} style={{ background:"none", border:"1px solid rgba(255,255,255,0.15)", borderRadius:8, padding:"4px 12px", fontSize:11, color:"rgba(255,255,255,0.4)", cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}>Refresh</button>
          </div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12, marginBottom:22 }}>
          {[
            { label:"Gross Revenue", val:"€"+Math.round(tRev).toLocaleString(),    gold:true,  ico:"💶" },
            { label:"Your Earnings", val:"€"+Math.round(ownerNet).toLocaleString(), gold:true,  ico:"💰" },
            { label:"Total Bookings",val:allBkg.length,                             ico:"📋" },
            { label:"Nights Sold",   val:tNights,                                   ico:"🌙" },
            { label:"Upcoming",      val:upcoming.length,                           ico:"⭐" },
          ].map(function(m,i) {
            return (
              <div key={i} style={Object.assign({},CS.m,m.gold?CS.mg:{})}>
                <div style={{ display:"flex", justifyContent:"space-between" }}>
                  <div style={CS.ml}>{m.label}</div>
                  <span style={{ fontSize:14 }}>{m.ico}</span>
                </div>
                <div style={Object.assign({},CS.mv,{ color:m.gold?GOLD:DARK })}>{loading?"…":m.val}</div>
              </div>
            );
          })}
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
          {[
            { title:"✈️ Arrivals Today",    list:arrivalsToday,  emptyIco:"🌅", emptyMsg:"No arrivals today",   isArrival:true  },
            { title:"🧳 Departures Today",  list:departingToday, emptyIco:"🏖️", emptyMsg:"No departures today", isArrival:false },
          ].map(function(g,gi) {
            return (
              <div key={gi} style={CS.card}>
                <div style={CS.ch}>
                  <span style={CS.ct}>{g.title}</span>
                  <span style={{ fontSize:11, color:"rgba(28,23,18,0.35)" }}>{todayStr}</span>
                </div>
                <div style={CS.cb}>
                  {loading
                    ? <div style={{ color:"rgba(28,23,18,0.35)", fontSize:13 }}>Loading…</div>
                    : g.list.length
                      ? g.list.map(function(b,i) {
                          const rn=roomName(b); const rc=getRoomColor(rn);
                          return (
                            <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 0", borderBottom:i<g.list.length-1?"1px solid rgba(200,149,108,0.07)":"none" }}>
                              <div style={{ width:36,height:36,borderRadius:10,background:rc.light,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:rc.text,flexShrink:0 }}>{getRoomShort(rn).charAt(0)}</div>
                              <div style={{ flex:1,minWidth:0 }}>
                                <div style={{ fontWeight:600,fontSize:13,color:DARK }}>{guestName(b)}</div>
                                <div style={{ fontSize:11,color:"rgba(28,23,18,0.4)",marginTop:1 }}>{getRoomShort(rn)} · {calcNights(b.arrival,b.departure)} nights</div>
                              </div>
                              {g.isArrival
                                ? <div style={{ fontWeight:700,color:"#27ae60",fontSize:13 }}>€{parseFloat(b.price||0).toFixed(0)}</div>
                                : <div style={{ fontSize:11,background:"rgba(231,76,60,0.08)",color:"#e74c3c",border:"1px solid rgba(231,76,60,0.15)",borderRadius:999,padding:"2px 8px",fontWeight:600 }}>Checkout</div>
                              }
                            </div>
                          );
                        })
                      : <div style={{ textAlign:"center", padding:"22px 0" }}>
                          <div style={{ fontSize:28,marginBottom:8 }}>{g.emptyIco}</div>
                          <div style={{ fontSize:13,color:"rgba(28,23,18,0.35)" }}>{g.emptyMsg}</div>
                        </div>
                  }
                </div>
              </div>
            );
          })}
        </div>

        <div style={CS.card}>
          <div style={CS.ch}><span style={CS.ct}>📆 Next Arrivals</span><span style={{ fontSize:11,color:"rgba(28,23,18,0.35)" }}>Coming up soon</span></div>
          <div style={CS.cb}>
            {loading
              ? <div style={{ color:"rgba(28,23,18,0.35)",fontSize:13 }}>Loading…</div>
              : upcoming.slice(0,5).map(function(b,i) {
                  const rn=roomName(b); const rc=getRoomColor(rn);
                  const daysUntil=Math.ceil((new Date(b.arrival)-today)/86400000);
                  return (
                    <div key={i} style={{ display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<4?"1px solid rgba(200,149,108,0.07)":"none" }}>
                      <div style={{ width:44,height:44,borderRadius:12,background:rc.light,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",flexShrink:0,border:"1px solid "+rc.bg+"33" }}>
                        <div style={{ fontSize:9,fontWeight:700,color:rc.text,textTransform:"uppercase",letterSpacing:1 }}>{new Date(b.arrival).toLocaleDateString("en",{month:"short"})}</div>
                        <div style={{ fontSize:16,fontWeight:700,color:rc.text,lineHeight:1 }}>{new Date(b.arrival).getDate()}</div>
                      </div>
                      <div style={{ flex:1,minWidth:0 }}>
                        <div style={{ fontWeight:600,fontSize:13,color:DARK }}>{guestName(b)}</div>
                        <div style={{ fontSize:11,color:"rgba(28,23,18,0.4)",marginTop:1 }}>{getRoomShort(rn)} · {calcNights(b.arrival,b.departure)} nights</div>
                      </div>
                      <div style={{ textAlign:"right",flexShrink:0 }}>
                        <div style={{ fontWeight:700,color:"#27ae60",fontSize:13 }}>€{parseFloat(b.price||0).toFixed(0)}</div>
                        <div style={{ fontSize:10,color:daysUntil<=3?"#e74c3c":"rgba(28,23,18,0.35)",marginTop:2 }}>{daysUntil}d away</div>
                      </div>
                    </div>
                  );
                })
            }
            {!loading && upcoming.length===0 && <div style={{ textAlign:"center",padding:20,color:"rgba(28,23,18,0.35)",fontSize:13 }}>No upcoming arrivals.</div>}
          </div>
        </div>
      </div>
    );
  }

  // ── CALENDAR TIMELINE ──
  function renderBookings() {
    const daysInMonth = new Date(calYear, calMonth+1, 0).getDate();
    const days = [];
    for (var i=1; i<=daysInMonth; i++) days.push(i);

    function bKey(b) { return b.roomId+"_"+b.unitId; }
    var rowMap = {};
    allBkg.forEach(function(b) {
      var k=bKey(b);
      if (!rowMap[k]) { rowMap[k]={ key:k, label:getRoomShort(roomName(b)), fullName:roomName(b), roomId:b.roomId, unitId:b.unitId }; }
    });
    var rows = Object.values(rowMap).sort(function(a,b){ return a.roomId-b.roomId||a.unitId-b.unitId; });

    function getSpan(b) {
      var ms = new Date(calYear,calMonth,1);
      var me = new Date(calYear,calMonth+1,0);
      var arr = new Date(b.arrival);
      var dep = new Date(b.departure);
      if (arr>me||dep<=ms) return null;
      var startInMonth = arr.getMonth()===calMonth&&arr.getFullYear()===calYear;
      var endInMonth   = dep.getMonth()===calMonth&&dep.getFullYear()===calYear;
      return {
        startDay: startInMonth?arr.getDate():1,
        endDay:   endInMonth?dep.getDate():daysInMonth+1,
        startsHere: startInMonth,
        endsHere:   endInMonth,
      };
    }

    var COL_W = 34;
    var ROW_H = 54;
    var LEFT_W = 150;
    var todayDay = (today.getMonth()===calMonth&&today.getFullYear()===calYear)?today.getDate():null;

    return (
      <div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20, flexWrap:"wrap", gap:10 }}>
          <div>
            <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.7rem", fontWeight:400, color:DARK }}>{MONTHS[calMonth]} {calYear}</h2>
            <p style={{ fontSize:12, color:"rgba(28,23,18,0.4)", marginTop:2 }}>Click any booking bar to see guest details</p>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <button onClick={function(){ calMonth===0?(setCalMonth(11),setCalYear(function(y){return y-1;})):setCalMonth(function(m){return m-1;}); }} style={{ width:34,height:34,borderRadius:8,border:"1px solid rgba(200,149,108,0.2)",background:"#fff",cursor:"pointer",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center",color:DARK }}>‹</button>
            <button onClick={function(){ setCalMonth(new Date().getMonth()); setCalYear(new Date().getFullYear()); }} style={{ padding:"6px 14px",borderRadius:8,border:"1px solid "+GOLD,background:"rgba(200,149,108,0.06)",color:GOLD,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'DM Sans',sans-serif" }}>Today</button>
            <button onClick={function(){ calMonth===11?(setCalMonth(0),setCalYear(function(y){return y+1;})):setCalMonth(function(m){return m+1;}); }} style={{ width:34,height:34,borderRadius:8,border:"1px solid rgba(200,149,108,0.2)",background:"#fff",cursor:"pointer",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center",color:DARK }}>›</button>
            <button onClick={function(){ setBookings(null); fetchBookings(); }} style={{ padding:"6px 12px",borderRadius:8,border:"1px solid rgba(200,149,108,0.2)",background:"#fff",color:"rgba(28,23,18,0.5)",fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif" }}>↻</button>
          </div>
        </div>

        <div style={{ background:"#fff", border:"1px solid rgba(200,149,108,0.15)", borderRadius:18, overflow:"hidden", boxShadow:"0 4px 24px rgba(28,23,18,0.07)" }}>
          {/* Header */}
          <div style={{ display:"flex", borderBottom:"2px solid rgba(200,149,108,0.12)" }}>
            <div style={{ width:LEFT_W, flexShrink:0, background:DARK, padding:"12px 16px", display:"flex", alignItems:"center" }}>
              <span style={{ fontSize:10, fontWeight:700, letterSpacing:2, textTransform:"uppercase", color:"rgba(255,255,255,0.3)" }}>Room</span>
            </div>
            <div style={{ overflowX:"auto", flex:1 }}>
              <div style={{ display:"flex", minWidth:daysInMonth*COL_W }}>
                {days.map(function(d) {
                  var dateStr=calYear+"-"+String(calMonth+1).padStart(2,"0")+"-"+String(d).padStart(2,"0");
                  var dow=(new Date(dateStr).getDay()+6)%7;
                  var isWeekend=dow>=5;
                  var isToday=d===todayDay;
                  return (
                    <div key={d} style={{ width:COL_W, flexShrink:0, padding:"8px 0", textAlign:"center", background:isToday?"rgba(200,149,108,0.15)":DARK, borderLeft:"1px solid rgba(255,255,255,0.04)", position:"relative" }}>
                      <div style={{ fontSize:9, color:isWeekend?GOLD2:"rgba(255,255,255,0.3)", marginBottom:2, textTransform:"uppercase", letterSpacing:1 }}>{DAYS_SHORT[dow]}</div>
                      <div style={{ fontSize:13, fontWeight:isToday?700:500, color:isToday?GOLD:isWeekend?"rgba(255,255,255,0.8)":"rgba(255,255,255,0.6)" }}>{d}</div>
                      {isToday&&<div style={{ position:"absolute", bottom:0, left:"50%", transform:"translateX(-50%)", width:4, height:4, borderRadius:"50%", background:GOLD }} />}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Rows */}
          {loading
            ? <div style={{ padding:40, textAlign:"center", color:"rgba(28,23,18,0.35)", fontSize:13 }}>Loading bookings…</div>
            : rows.length===0
              ? <div style={{ padding:40, textAlign:"center", color:"rgba(28,23,18,0.35)", fontSize:13 }}>No bookings this month.</div>
              : rows.map(function(row,ri) {
                  var rowBkgs=allBkg.filter(function(b){ return bKey(b)===row.key && b.arrival && b.departure; });
                  var rc=getRoomColor(row.fullName||row.label);
                  return (
                    <div key={row.key} style={{ display:"flex", borderBottom:ri<rows.length-1?"1px solid rgba(200,149,108,0.07)":"none" }}>
                      <div style={{ width:LEFT_W, flexShrink:0, padding:"0 14px", display:"flex", alignItems:"center", gap:8, background:"rgba(28,23,18,0.012)", borderRight:"1px solid rgba(200,149,108,0.08)", minHeight:ROW_H }}>
                        <div style={{ width:8, height:8, borderRadius:"50%", background:rc.bg, flexShrink:0 }} />
                        <span style={{ fontSize:11, fontWeight:600, color:DARK, lineHeight:1.3 }}>{row.label}</span>
                      </div>
                      <div style={{ flex:1, overflowX:"auto" }}>
                        <div style={{ position:"relative", minWidth:daysInMonth*COL_W, height:ROW_H }}>
                          {days.map(function(d) {
                            var dateStr=calYear+"-"+String(calMonth+1).padStart(2,"0")+"-"+String(d).padStart(2,"0");
                            var isToday2=d===todayDay;
                            var dow=(new Date(dateStr).getDay()+6)%7;
                            var isWeekend=dow>=5;
                            return <div key={d} style={{ position:"absolute", left:(d-1)*COL_W, top:0, width:COL_W, height:"100%", borderLeft:"1px solid rgba(200,149,108,0.06)", background:isToday2?"rgba(200,149,108,0.05)":isWeekend?"rgba(200,149,108,0.015)":"transparent" }} />;
                          })}
                          {rowBkgs.map(function(b,bi) {
                            var span=getSpan(b);
                            if (!span) return null;
                            var s=span.startDay; var e=span.endDay;
                            var sh=span.startsHere; var eh=span.endsHere;
                            var left=(s-1)*COL_W+(sh?3:0);
                            var width=(e-s)*COL_W-(sh?3:0)-(eh?3:0);
                            var isSel=selectedBkg&&selectedBkg.id===b.id;

                            // ── STATUS COLOUR LOGIC ──
                            var isArrivingToday = b.arrival === todayStr;
                            var isDepartingToday = b.departure === todayStr;
                            var arrDate = b.arrival ? new Date(b.arrival) : null;
                            var depDate = b.departure ? new Date(b.departure) : null;
                            var isCheckedIn = arrDate && depDate && arrDate <= today && depDate > today && !isArrivingToday;

                            var barGradient;
                            var barShadow;
                            if (isArrivingToday) {
                              // Blue — arriving today
                              barGradient = "linear-gradient(90deg,#1a6fa8,#2980b9,#3b9fd4)";
                              barShadow = isSel ? "0 0 0 2px #fff, 0 0 0 4px #2980b9" : "0 2px 10px rgba(41,128,185,0.5)";
                            } else if (isDepartingToday) {
                              // Red — checking out today
                              barGradient = "linear-gradient(90deg,#c0392b,#e74c3c,#f06060)";
                              barShadow = isSel ? "0 0 0 2px #fff, 0 0 0 4px #e74c3c" : "0 2px 10px rgba(231,76,60,0.5)";
                            } else if (isCheckedIn) {
                              // Green — currently checked in
                              barGradient = "linear-gradient(90deg,#1e8449,#27ae60,#2ecc71)";
                              barShadow = isSel ? "0 0 0 2px #fff, 0 0 0 4px #27ae60" : "0 2px 10px rgba(39,174,96,0.5)";
                            } else {
                              // Default room colour for future bookings
                              var rc2=getRoomColor(roomName(b));
                              barGradient = rc2.gradient;
                              barShadow = isSel ? "0 0 0 2px #fff, 0 0 0 4px "+rc2.bg : "0 2px 8px rgba(0,0,0,0.2)";
                            }

                            return (
                              <div key={bi}
                                onClick={function(){ setSelectedBkg(isSel?null:b); }}
                                style={{
                                  position:"absolute", left:left, top:8, width:width, height:ROW_H-16,
                                  background:barGradient,
                                  borderRadius:(sh?8:0)+"px "+(eh?8:0)+"px "+(eh?8:0)+"px "+(sh?8:0)+"px",
                                  cursor:"pointer", overflow:"hidden",
                                  display:"flex", alignItems:"center", paddingLeft:sh?10:4,
                                  boxShadow:barShadow,
                                  transition:"box-shadow .2s, transform .15s",
                                  transform:isSel?"scaleY(1.06)":"scaleY(1)",
                                  zIndex:isSel?10:1,
                                }}>
                                {width>28&&(
                                  <span style={{ fontSize:13, fontWeight:700, color:"#fff", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", textShadow:"0 1px 4px rgba(0,0,0,0.4)" }}>
                                    {isArrivingToday ? "✈ " : isDepartingToday ? "🧳 " : isCheckedIn ? "● " : ""}
                                    {guestName(b).split(" ")[0]}{width>100 ? " "+(guestName(b).split(" ")[1]||"") : ""}
                                  </span>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })
          }
        </div>

        {/* Detail panel */}
        {selectedBkg&&(function(){
          var b=selectedBkg;
          var rn=roomName(b); var rc=getRoomColor(rn); var src=getSource(b);
          var srcColor=src==="Booking.com"?"#2980b9":src==="Airbnb"?"#e74c3c":GOLD;
          return (
            <div style={{ marginTop:16, background:"#fff", border:"2px solid "+rc.bg+"44", borderRadius:18, overflow:"hidden", boxShadow:"0 8px 32px rgba(28,23,18,0.10)" }}>
              <div style={{ height:5, background:rc.gradient }} />
              <div style={{ padding:"20px 24px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12 }}>
                  <div>
                    <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.5rem", fontWeight:400, color:DARK, marginBottom:4 }}>{guestName(b)}</div>
                    <div style={{ fontSize:13, color:"rgba(28,23,18,0.5)" }}>{rn}</div>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.8rem", fontWeight:400, color:"#27ae60" }}>€{parseFloat(b.price||0).toFixed(0)}</div>
                    <button onClick={function(){ setSelectedBkg(null); }} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"rgba(28,23,18,0.3)" }}>✕</button>
                  </div>
                </div>
                <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginTop:14 }}>
                  {[
                    { label:"Check-in",  val:formatD(b.arrival) },
                    { label:"Check-out", val:formatD(b.departure) },
                    { label:"Nights",    val:calcNights(b.arrival,b.departure) },
                    { label:"Guests",    val:(b.numAdult||1)+" adults"+(b.numChild?" + "+b.numChild+" child":"") },
                    { label:"Source",    val:src, color:srcColor },
                  ].map(function(item,i) {
                    return (
                      <div key={i} style={{ background:"rgba(200,149,108,0.06)", border:"1px solid rgba(200,149,108,0.12)", borderRadius:10, padding:"8px 14px" }}>
                        <div style={{ fontSize:9, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:"rgba(28,23,18,0.35)", marginBottom:3 }}>{item.label}</div>
                        <div style={{ fontSize:13, fontWeight:600, color:item.color||DARK }}>{item.val}</div>
                      </div>
                    );
                  })}
                  {b.comments&&(
                    <div style={{ background:"rgba(200,149,108,0.06)", border:"1px solid rgba(200,149,108,0.12)", borderRadius:10, padding:"8px 14px", flex:1, minWidth:160 }}>
                      <div style={{ fontSize:9, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:"rgba(28,23,18,0.35)", marginBottom:3 }}>Notes</div>
                      <div style={{ fontSize:12, color:"rgba(28,23,18,0.6)" }}>{b.comments}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })()}

        <div style={{ display:"flex", gap:16, flexWrap:"wrap", marginTop:14, padding:"8px 0", alignItems:"center" }}>
          <span style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:"rgba(28,23,18,0.3)", marginRight:4 }}>Status:</span>
          {[
            { label:"Checked In",    gradient:"linear-gradient(90deg,#1e8449,#27ae60)", border:"rgba(39,174,96,0.3)" },
            { label:"Arriving Today",gradient:"linear-gradient(90deg,#1a6fa8,#2980b9)", border:"rgba(41,128,185,0.3)" },
            { label:"Checking Out",  gradient:"linear-gradient(90deg,#c0392b,#e74c3c)", border:"rgba(231,76,60,0.3)" },
            { label:"Upcoming",      gradient:"linear-gradient(90deg,#7f8c8d,#95a5a6)", border:"rgba(127,140,141,0.3)" },
          ].map(function(s,i) {
            return (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, fontWeight:500, color:"rgba(28,23,18,0.6)" }}>
                <div style={{ width:20, height:10, borderRadius:4, background:s.gradient, border:"1px solid "+s.border }} />
                {s.label}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // ── REVENUE ──
  function renderRevenue() {
    var monthly={};
    allBkg.forEach(function(b) {
      if (!b.arrival) return;
      var key=b.arrival.substring(0,7);
      if (!monthly[key]) monthly[key]={ month:key, bookings:0, nights:0, revenue:0 };
      monthly[key].bookings++;
      monthly[key].nights+=calcNights(b.arrival,b.departure);
      monthly[key].revenue+=parseFloat(b.price||0);
    });
    var months=Object.values(monthly).sort(function(a,b){ return a.month.localeCompare(b.month); });
    var maxMRev=Math.max.apply(null,months.map(function(m){ return m.revenue; }).concat([1]));

    var byRoom={};
    allBkg.forEach(function(b) {
      var rn=roomName(b); var sh=getRoomShort(rn);
      if (!byRoom[sh]) byRoom[sh]={ name:rn, short:sh, revenue:0, count:0 };
      byRoom[sh].revenue+=parseFloat(b.price||0);
      byRoom[sh].count++;
    });
    var rooms=Object.values(byRoom).sort(function(a,b){ return b.revenue-a.revenue; });
    var maxRRev=Math.max.apply(null,rooms.map(function(r){ return r.revenue; }).concat([1]));

    var byCh={};
    allBkg.forEach(function(b) {
      var ch=getSource(b);
      if (!byCh[ch]) byCh[ch]={ revenue:0, count:0 };
      byCh[ch].revenue+=parseFloat(b.price||0);
      byCh[ch].count++;
    });
    var chColors={"Booking.com":"#2980b9","Airbnb":"#e74c3c","Direct":GOLD};
    var chEntries=Object.entries(byCh).sort(function(a,b){ return b[1].revenue-a[1].revenue; });
    var adr=allBkg.length>0?tRev/allBkg.length:0;
    var topRoom=rooms[0];

    return (
      <div>
        {/* KPI dark cards */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(155px,1fr))", gap:14, marginBottom:22 }}>
          {[
            { label:"Total Bookings",  val:allBkg.length,                              sub:"All reservations" },
            { label:"Total Revenue",   val:"€"+Math.round(tRev).toLocaleString(),      sub:"Gross amount",         gold:true },
            { label:"Average Booking", val:"€"+Math.round(adr).toLocaleString(),       sub:"Per reservation" },
            { label:"Top Room",        val:topRoom?topRoom.short:"—",                  sub:topRoom?"€"+Math.round(topRoom.revenue).toLocaleString()+" total":"" },
            { label:"Your Net",        val:"€"+Math.round(ownerNet).toLocaleString(),  sub:"After "+commPct+"% commission", gold:true },
          ].map(function(m,i) {
            return (
              <div key={i} style={{ background:DARK, borderRadius:16, padding:"18px 20px", position:"relative", overflow:"hidden", boxShadow:"0 4px 20px rgba(28,23,18,0.15)" }}>
                <div style={{ position:"absolute", top:-20, right:-20, width:80, height:80, background:m.gold?"rgba(200,149,108,0.12)":"rgba(255,255,255,0.03)", borderRadius:"50%" }} />
                <div style={{ fontSize:9, fontWeight:700, textTransform:"uppercase", letterSpacing:2, color:m.gold?GOLD:"rgba(255,255,255,0.35)", marginBottom:10 }}>{m.label}</div>
                <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.65rem", fontWeight:400, color:m.gold?GOLD:"#fff", lineHeight:1, marginBottom:6 }}>{loading?"…":m.val}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.3)" }}>{m.sub}</div>
              </div>
            );
          })}
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1.35fr 1fr", gap:18, marginBottom:18 }}>
          {/* Monthly Breakdown — NOW FIRST / TOP LEFT */}
          <div style={{ background:DARK, borderRadius:18, padding:"22px 24px", boxShadow:"0 4px 20px rgba(28,23,18,0.15)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:2, color:"rgba(255,255,255,0.4)" }}>Monthly Breakdown</div>
              <div style={{ display:"flex", gap:16, fontSize:11 }}>
                <span style={{ color:GOLD }}>Gross</span>
                <span style={{ color:"#27ae60" }}>Your Net</span>
              </div>
            </div>
            {months.length>0&&(
              <div style={{ display:"flex", gap:8, alignItems:"flex-end", height:140, marginBottom:20 }}>
                {months.map(function(m,i) {
                  var grossPct=(m.revenue/maxMRev)*100;
                  var netPct=((m.revenue*(1-commPct/100))/maxMRev)*100;
                  return (
                    <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
                      <div style={{ fontSize:9, color:GOLD, fontWeight:700, marginBottom:2 }}>{m.revenue>0?"€"+Math.round(m.revenue/1000)+"k":""}</div>
                      <div style={{ width:"100%", display:"flex", gap:2, alignItems:"flex-end", height:100 }}>
                        <div style={{ flex:1, height:grossPct+"%", background:"linear-gradient(180deg,"+GOLD2+","+GOLD+")", borderRadius:"4px 4px 0 0", minHeight:m.revenue>0?4:0 }} />
                        <div style={{ flex:1, height:netPct+"%", background:"linear-gradient(180deg,#2ecc71,#27ae60)", borderRadius:"4px 4px 0 0", minHeight:m.revenue>0?4:0 }} />
                      </div>
                      <div style={{ fontSize:9, color:"rgba(255,255,255,0.4)", marginTop:3 }}>{m.month.replace("2026-","")}</div>
                    </div>
                  );
                })}
              </div>
            )}
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", minWidth:400 }}>
                <thead>
                  <tr>{["Month","Bookings","Nights","Gross","Commission","Your Net"].map(function(h) {
                    return <th key={h} style={{ fontSize:9, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:"rgba(255,255,255,0.3)", padding:"8px 10px", textAlign:"left", borderBottom:"1px solid rgba(255,255,255,0.06)" }}>{h}</th>;
                  })}</tr>
                </thead>
                <tbody>
                  {months.map(function(m) {
                    var comm=m.revenue*commPct/100; var net=m.revenue-comm;
                    return (
                      <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                        <td style={{ padding:"10px", fontSize:13, fontWeight:600, color:"#fff" }}>{m.month}</td>
                        <td style={{ padding:"10px", fontSize:13, color:"rgba(255,255,255,0.6)" }}>{m.bookings}</td>
                        <td style={{ padding:"10px", fontSize:13, color:"rgba(255,255,255,0.6)" }}>{m.nights}</td>
                        <td style={{ padding:"10px", fontSize:13, fontWeight:600, color:GOLD }}>€{Math.round(m.revenue).toLocaleString()}</td>
                        <td style={{ padding:"10px", fontSize:13, color:"#e74c3c" }}>-€{Math.round(comm).toLocaleString()}</td>
                        <td style={{ padding:"10px", fontSize:13, fontWeight:700, color:"#27ae60" }}>€{Math.round(net).toLocaleString()}</td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr style={{ borderTop:"2px solid rgba(200,149,108,0.25)" }}>
                    <td style={{ padding:"10px", fontSize:12, fontWeight:700, color:"rgba(255,255,255,0.5)" }}>TOTAL</td>
                    <td style={{ padding:"10px", fontSize:13, fontWeight:700, color:"#fff" }}>{allBkg.length}</td>
                    <td style={{ padding:"10px", fontSize:13, fontWeight:700, color:"#fff" }}>{tNights}</td>
                    <td style={{ padding:"10px", fontSize:14, fontWeight:700, color:GOLD }}>€{Math.round(tRev).toLocaleString()}</td>
                    <td style={{ padding:"10px", fontSize:13, fontWeight:700, color:"#e74c3c" }}>-€{Math.round(tRev*commPct/100).toLocaleString()}</td>
                    <td style={{ padding:"10px", fontSize:14, fontWeight:700, color:"#27ae60" }}>€{Math.round(ownerNet).toLocaleString()}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Channel donut — stays on right */}
          <div style={{ background:DARK, borderRadius:18, padding:"22px 24px", boxShadow:"0 4px 20px rgba(28,23,18,0.15)" }}>
            <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:2, color:"rgba(255,255,255,0.4)", marginBottom:20 }}>Revenue by Channel</div>
            {chEntries.length>0&&(function(){
              var size=130; var r2=44; var cx=65; var cy=65; var circ=2*Math.PI*r2;
              var offset=0;
              var arcs=chEntries.map(function(e) {
                var pct=tRev>0?e[1].revenue/tRev:0;
                var arc={ ch:e[0], pct:pct, offset:offset, color:chColors[e[0]]||"#7f8c8d" };
                offset+=pct; return arc;
              });
              return (
                <div style={{ display:"flex", justifyContent:"center", marginBottom:20 }}>
                  <svg width={size} height={size} viewBox={"0 0 "+size+" "+size}>
                    <circle cx={cx} cy={cy} r={r2} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="18" />
                    {arcs.map(function(a,i) {
                      return (
                        <circle key={i} cx={cx} cy={cy} r={r2} fill="none"
                          stroke={a.color} strokeWidth="18"
                          strokeDasharray={a.pct*circ+" "+circ}
                          strokeDashoffset={-a.offset*circ+circ/4}
                        />
                      );
                    })}
                    <text x={cx} y={cy-4} textAnchor="middle" fill="#fff" fontSize="14" fontWeight="700" fontFamily="DM Sans,sans-serif">{allBkg.length}</text>
                    <text x={cx} y={cy+10} textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="10" fontFamily="DM Sans,sans-serif">bookings</text>
                  </svg>
                </div>
              );
            })()}
            {chEntries.map(function(e,i) {
              var ch=e[0]; var data=e[1];
              var pct=tRev>0?(data.revenue/tRev*100):0;
              var color=chColors[ch]||"#7f8c8d";
              return (
                <div key={i} style={{ marginBottom:12 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                      <div style={{ width:10, height:10, borderRadius:"50%", background:color }} />
                      <span style={{ fontSize:12, fontWeight:600, color:"#fff" }}>{ch}</span>
                      <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{data.count} bkg</span>
                    </div>
                    <div>
                      <span style={{ fontSize:12, fontWeight:700, color:color }}>{Math.round(pct)}%</span>
                      <span style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginLeft:6 }}>€{Math.round(data.revenue).toLocaleString()}</span>
                    </div>
                  </div>
                  <div style={{ height:5, background:"rgba(255,255,255,0.06)", borderRadius:999, overflow:"hidden" }}>
                    <div style={{ height:"100%", width:pct+"%", background:color, borderRadius:999 }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Revenue by Room Type — NOW SECOND / BOTTOM */}
        <div style={{ background:DARK, borderRadius:18, padding:"22px 24px", boxShadow:"0 4px 20px rgba(28,23,18,0.15)", marginBottom:18 }}>
          <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:2, color:"rgba(255,255,255,0.4)", marginBottom:20 }}>Revenue by Room Type</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:16 }}>
            {rooms.map(function(r,i) {
              var rc=getRoomColor(r.name);
              var pct=(r.revenue/maxRRev)*100;
              var net=r.revenue-(r.revenue*commPct/100);
              return (
                <div key={i} style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(200,149,108,0.1)", borderRadius:14, padding:"16px 18px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                    <span style={{ fontSize:13, fontWeight:600, color:"#fff" }}>{r.short}</span>
                    <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{r.count} bookings</span>
                  </div>
                  <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.4rem", fontWeight:400, color:rc.text, marginBottom:4 }}>€{Math.round(r.revenue).toLocaleString()}</div>
                  <div style={{ height:6, background:"rgba(255,255,255,0.06)", borderRadius:999, overflow:"hidden", marginBottom:6 }}>
                    <div style={{ height:"100%", width:pct+"%", background:rc.gradient, borderRadius:999 }} />
                  </div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.3)" }}>Net → €{Math.round(net).toLocaleString()}</div>
                </div>
              );
            })}
            {rooms.length===0&&<div style={{ color:"rgba(255,255,255,0.3)", fontSize:13 }}>{loading?"Loading…":"No data yet."}</div>}
          </div>
        </div>
      </div>
    );
  }

  var tabTitles={
    dashboard:["My Dashboard",     owner.property+" · Live Overview"],
    bookings: ["Booking Calendar",  "Timeline · click any booking for full details"],
    revenue:  ["My Revenue",        "Visual earnings & performance report"],
  };
  var titleArr=tabTitles[tab]||[tab,""];

  return (
    <div style={{ display:"flex", minHeight:"100vh", fontFamily:"'DM Sans',sans-serif", background:CREAM, color:DARK }}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500&family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

      <aside style={{ width:210, background:DARK, display:"flex", flexDirection:"column", flexShrink:0, position:"sticky", top:0, height:"100vh" }}>
        <div style={{ padding:"20px 18px 16px", borderBottom:"1px solid rgba(200,149,108,0.12)" }}>
          <div style={{ fontSize:9, fontWeight:700, letterSpacing:3, textTransform:"uppercase", color:GOLD, opacity:.8, marginBottom:5 }}>Owner Portal</div>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.3rem", fontWeight:400, color:"#fff", lineHeight:1.1 }}>{owner.property}</div>
          <div style={{ fontSize:10, color:"rgba(255,255,255,0.25)", marginTop:3 }}>{owner.location}</div>
        </div>
        <div style={{ padding:"10px 16px", background:"rgba(200,149,108,0.06)", borderBottom:"1px solid rgba(200,149,108,0.1)", display:"flex", alignItems:"center", gap:8 }}>
          <div style={{ width:28, height:28, borderRadius:"50%", background:GOLD, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, color:"#fff", flexShrink:0 }}>{owner.name&&owner.name[0]}</div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:12, fontWeight:600, color:"#fff", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{owner.name}</div>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>Property Owner</div>
          </div>
          <button onClick={logout} title="Logout" style={{ background:"none", border:"none", color:"rgba(255,255,255,0.25)", cursor:"pointer", fontSize:14 }}>⏻</button>
        </div>
        <nav style={{ flex:1, padding:"10px 0" }}>
          {NAV.map(function(item) {
            return (
              <button key={item.id} onClick={function(){ setTab(item.id); }} style={{ display:"flex", alignItems:"center", gap:9, padding:"9px 18px", fontSize:13, fontWeight:500, width:"100%", textAlign:"left", background:tab===item.id?"rgba(200,149,108,0.1)":"none", color:tab===item.id?"#fff":"rgba(255,255,255,0.45)", border:"none", borderLeft:tab===item.id?"2px solid "+GOLD:"2px solid transparent", cursor:"pointer", fontFamily:"'DM Sans',sans-serif", transition:"all .2s" }}>
                <span style={{ fontSize:15, width:18, textAlign:"center" }}>{item.ico}</span>
                {item.label}
              </button>
            );
          })}
        </nav>
        <div style={{ padding:"14px 18px", borderTop:"1px solid rgba(200,149,108,0.1)" }}>
          <p style={{ fontSize:10, color:"rgba(255,255,255,0.2)", textAlign:"center" }}>Booking Albania · 2026</p>
        </div>
      </aside>

      <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
        <div style={{ background:"#fff", borderBottom:"1px solid rgba(200,149,108,0.15)", padding:"0 24px", height:56, display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:40 }}>
          <div>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:"1.2rem", fontWeight:400, color:DARK }}>{titleArr[0]}</div>
            <div style={{ fontSize:11, color:"rgba(28,23,18,0.35)" }}>{titleArr[1]}</div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:6 }}>
            <div style={{ width:7, height:7, background:"#27ae60", borderRadius:"50%" }} />
            <span style={{ fontSize:11, color:"#27ae60", fontWeight:600 }}>Live</span>
          </div>
        </div>
        <div style={{ padding:"22px 24px", flex:1, overflowX:"hidden" }}>
          {tab==="dashboard"&&renderDashboard()}
          {tab==="bookings" &&renderBookings()}
          {tab==="revenue"  &&renderRevenue()}
        </div>
      </div>

      <style>{"* { box-sizing: border-box; }"}</style>
    </div>
  );
}